import { DialogService, GridButton } from '@eforall/dashboard';
import { AccTeamDialogDataService } from '../../acc-team-dialog-data.service';
import { AddVentureDialog, AddVentureDialogContextData } from '../add-venture/add-venture.dialog';


export function getButtons(dialogService: DialogService, dialogDataService: AccTeamDialogDataService): GridButton[] {

	const buttons: GridButton[] = [];

	const addVenture: GridButton = {
		iconClass: 'fa-plus',
		label: 'Add Venture',
		execute: async () => {
			const accTeamDialogData = dialogDataService.dialogData();
			if (!accTeamDialogData) return;

			const data: AddVentureDialogContextData = {
				accVentures: accTeamDialogData.accVentures,
				accTeamId: accTeamDialogData.accTeamId,
			};
			await dialogService.showCustom(AddVentureDialog, { data }, 500, 400);
			await dialogDataService.reloadData();
		}
	};

	if (dialogDataService.canEdit()) {
		buttons.push(addVenture);
	}

	return buttons;
}